import {
  Button,
  Checkbox,
  Fieldset,
  Flex,
  LoadingOverlay,
} from "@mantine/core";
import { useHotkeys } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import React, { useState } from "react";
import { repositoryPos } from "../../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../../model/MessageResponse";
import { SerialItemLKLR } from "../WarehouseOutWardActionV2";
type Props = {
  id: number;
  type: string;
  onhandlePrint: (
    id: string | number,
    type: string | null,
    printOption?: any,
  ) => void;
  setValuePrintOptionModal: any;
  isTMDT: any;
  isTmdtOrder?: boolean;
  setDataLinhKienLR?: React.Dispatch<React.SetStateAction<SerialItemLKLR[] | null>>;
  seriaLinhKienLR?: any[] | null;
  location?: any;
};
const OptionPrintOutWard = ({
  id,
  type,
  onhandlePrint,
  setValuePrintOptionModal,
  isTMDT,
  isTmdtOrder = false,
  setDataLinhKienLR,
  seriaLinhKienLR,
  location,
}: Props) => {
  const [valueOptionCheck, setValueOptionCheck] = useState({
    option1: "Serial",
    option2: isTmdtOrder ? "khongGia" : "coGia",
    dichVuDiKem: true,
    inLinhKienLR: false,
    inQR: isTmdtOrder ? false : true,
  });
  const [Loading, setLoading] = useState(false);
  const fetchDataLinhKienLR = async () => {
    setLoading(true);
    try {
      // seriaLinhKienLR có thể là mảng object hoặc mảng string
      const serialList: string[] = (
        Array.isArray(seriaLinhKienLR)
          ? seriaLinhKienLR.map((s: any) =>
              typeof s === "string" ? s.trim() : String(s?.serial ?? "").trim(),
            )
          : []
      ).filter((x) => !!x);

      if (serialList.length === 0) {
        NotificationExtension.Warn("Không có serial để lấy linh kiện.");
        return null;
      }

      const response = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/TblItemTransaction/get-serial-parent-info`,
        { parentSerial: serialList },
      );
      return response;
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };
  const onhandleSubmit = async () => {
    setValuePrintOptionModal(valueOptionCheck);
    if (valueOptionCheck.option1 === "" || valueOptionCheck.option2 === "") {
      NotificationExtension.Fails(
        "Vui lòng chọn đầy đủ lựa chọn hiển thị 1 và 2 của phiếu in",
      );
    } else {
      if (valueOptionCheck.inLinhKienLR && seriaLinhKienLR) {
        const response = await fetchDataLinhKienLR();
        if (response && response.data && response.success) {
          if (setDataLinhKienLR) {
            setDataLinhKienLR(response.data || []);
          }
        }
      }
      modals.closeAll();
      setTimeout(() => {
        onhandlePrint(id, type, valueOptionCheck);
      }, 1000);
    }
  };

  useHotkeys([
    [
      "enter",
      () => {
        onhandleSubmit();
      },
    ],
  ]);
  return (
    <div
      style={{
        marginTop: "20px",
        padding: "10px",
      }}
    >
      <LoadingOverlay visible={Loading} />
      <Flex
        direction={"row"}
        align={"center"}
        gap={"sm"}
        w={"100%"}
        justify={"space-between"}
      >
        <Fieldset legend="Lựa chọn hiển thị 1">
          <Flex direction={"column"} gap={"lg"} align={"left"} justify={"left"}>
            <Checkbox
              checked={valueOptionCheck.option1 === "Serial" ? true : false}
              value="Serial"
              label="Serial"
              onChange={() =>
                setValueOptionCheck((prev: any) => ({
                  ...prev,
                  option1: prev.option1 === "Serial" ? "" : "Serial",
                }))
              }
            />
            <Checkbox
              checked={valueOptionCheck.option1 === "Sl" ? true : false}
              value="Sl"
              label="Số lượng"
              onChange={() =>
                setValueOptionCheck((prev: any) => ({
                  ...prev,
                  option1: prev.option1 === "Sl" ? "" : "Sl",
                }))
              }
            />
          </Flex>
        </Fieldset>
        {!isTmdtOrder && (
          <Fieldset legend="Lựa chọn hiển thị 2">
            <Flex direction={"column"} gap={"lg"} align={"left"} justify={"left"}>
              <Checkbox
                checked={valueOptionCheck.option2 === "coGia" ? true : false}
                value="coGia"
                label="Có giá"
                onChange={() =>
                  setValueOptionCheck((prev: any) => ({
                    ...prev,
                    option2: prev.option2 === "coGia" ? "" : "coGia",
                  }))
                }
              />
              <Checkbox
                checked={valueOptionCheck.option2 === "khongGia" ? true : false}
                value="khongGia"
                label="Không giá"
                onChange={() =>
                  setValueOptionCheck((prev: any) => {
                    const isChoosingKhongGia = prev.option2 !== "khongGia";
                    return {
                      ...prev,
                      option2: isChoosingKhongGia ? "khongGia" : "",
                      ...(isChoosingKhongGia && { inQR: false }),
                    };
                  })
                }
              />
            </Flex>
          </Fieldset>
        )}
      </Flex>
      <Flex mt={"md"} justify={"space-around"} gap={"lg"}>
        <Checkbox
          checked={valueOptionCheck.dichVuDiKem}
          label="In dịch vụ đi kèm"
          onChange={(event) => {
            setValueOptionCheck((prev: any) => ({
              ...prev,
              dichVuDiKem: !!event.target.checked,
            }));
          }}
        />
        <Checkbox
          checked={valueOptionCheck.inLinhKienLR}
          label="In linh kiện LR"
          onChange={(event) => {
            setValueOptionCheck((prev: any) => ({
              ...prev,
              inLinhKienLR: !!event.target.checked,
            }));
          }}
        />
        <Checkbox
          checked={valueOptionCheck.inQR}
          label="In QR"
          onChange={(event) => {
            setValueOptionCheck((prev: any) => ({
              ...prev,
              inQR: !!event.target.checked,
            }));
          }}
        />
      </Flex>

      <Flex
        direction={"row"}
        justify={"center"}
        mt={"md"}
        w={"100%"}
        gap={"xs"}
      >
        <Button variant="filled" onClick={() => onhandleSubmit()}>
          In phiếu
        </Button>
        {isTMDT}
      </Flex>
    </div>
  );
};

export default OptionPrintOutWard;
